import React, { useContext } from 'react';
import { GolfParentContext } from '../cnr/contexts/GolfParentContext';
import GolferRow, { golferRowTypes, handicapModes } from './GolferRow';

const GolferTeam = (props) => {

  // golfParentContext 
  const golfParentContext = useContext(GolfParentContext)
  const { golfParent_contexts } = golfParentContext ?? {}
  const { fns } = golfParent_contexts ?? {}
  const { navigation_fns } = fns ?? {}

  const { golfer } = props

  const handleClick = (keyy) => navigation_fns.handleNav_item({ key: 'tournamentGolfers' }, keyy)

  const golferRow = () => <GolferRow
    golferRowType={golferRowTypes.team}
    golfer={golfer}
    handicapMode={handicapModes.tournament}
    handleClick={handleClick}
  />

  return golferRow()
}

export default GolferTeam